import { render, staticRenderFns } from "./MoleculeFeedProductsContentModalDelete.vue?vue&type=template&id=abafece4&"
import script from "./MoleculeFeedProductsContentModalDelete.vue?vue&type=script&lang=js&"
export * from "./MoleculeFeedProductsContentModalDelete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports